<div class="ngdialog-overlay" (click)="closeModal()" *ngIf="modal"></div>
<section class="pt-menu-example-row" [ngStyle]="{'height': isFromLogin ? 'auto' : '100%', 'padding-bottom': isFromLogin ? '0' : '10px',
  'padding-top': isFromLogin ? '0' : '10px'}">
  <div [dlsMenuTriggerFor]="menu" class="question-mark-manual Spacebox__l-small" [ngClass]="{'questionIcon': modal}"
       [ngStyle]="{'height': isFromLogin ? 'auto' : '100%', 'padding-bottom': isFromLogin ? '10px' : '0'}">
        <span [ngStyle]="{'font-size': isFromLogin ? 'x-large':'medium'}" class="icon__TN-unknown pointer"
              [dlsTooltip]="'Info'"
              [tooltipPosition]="'Bottom'"
              [tooltipClass]="'pt-primary'"
              [tooltipShowDelay]="1"
              [tooltipHideDelay]="10"></span>
  </div>
</section>

<dls-menu #menu (change)="generateFunc($event)">
  <div class="menu-title-wrapper">
    <dls-menu-item disabled="true">
      <span class="menu-title">Info</span>
    </dls-menu-item>
    <dls-menu-item class="menu-close-icon-wrapper">
      <dls-icon class="icon__close menu-close-icon"></dls-icon>
    </dls-menu-item>
  </div>
  <hr class="pt-separator menu-title-separator"/>

  <div *ngFor="let infoMenu of infoMenuList">
    <div class="menu-content" *ngIf="!isFromLogin || infoMenu.displayInLogin">
      <dls-menu-item [ngStyle]="{'padding-right': isFromLogin ? '100px' : '0'}">
        <dls-icon [class]=infoMenu.icon class="color-icon"></dls-icon>
        <label>{{infoMenu.title}}</label>
      </dls-menu-item>
      <hr/>
    </div>
  </div>
</dls-menu>

<div class="question-mark-manual-info-menu">
  <gen-panel
    [name]="supportPanelName"
    class="helpPanel"
    position="{{supportPanelPosition}}"
    (modal)="closeModal()">
  </gen-panel>
</div>

